import React, { useState, useEffect, useRef } from 'react';
import { ArticleContainer } from './styled';
import AnchorCoverTag from '../AnchorCoverTag';
import { useRouter } from 'next/router';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { getSearchParams } from '../../Parenting/common';
import { fireEvent } from '../../../Utils/fireEvent';
import { getWebUserId } from '../../../Utils/helper';
import { clickCardEvent } from '../../../Utils/StoreHomePageUtils';

function ArticleCardsHome(props) {
  const { data } = props;
  const [cardEffect, setCardEffect] = useState();
  const router = useRouter();

  const scrollRef = useRef(null);
  const itemRefs = useRef([]);
  const fired = useRef(new Set());
  const sectionId = 'ArticleSection';
    const firedImpressionsRef = useRef(new Set());

  const callbackFunction = (index, element) => {
    setCardEffect({ index: index, effect: 'lowOpacity' });
    clickCardEvent(element, data, false);
    setTimeout(() => {
      router.push(`${element?.webUrl}` + getSearchParams(), '', {
        locale: getRouterLocale(router),
      });
    }, [200]);
  };

  

 

   useEffect(() => {
      for (let i = 0; i < data.items.length; i++) {
       
        const video = document.getElementById(`${sectionId}-${i}`);
     
        if (video) {
      
          const options = {
            root: null, // use the viewport
            rootMargin: '0px',
            threshold: 0.18, // 50% of the video is visible
          };
  
          const handleIntersection = (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting ) {
               
                
                if (firedImpressionsRef.current.has(i)) return;
  
                firedImpressionsRef.current.add(i);
                const item = data.items[i];
               
  
               const t = data.items[i] || {};
          const product = t.product || {};
            fireEvent({
            category: 'Impression_card_in_store_home',
            card_name: t.title || t.heading || 'atricle_card',
            product_id: product.id || product._id || 'NA',
            user_data: {
              user_id: getWebUserId() || 'NA',
            
            },
            query_params:
              typeof window !== 'undefined'
                ? window.location.search || 'NA'
                : 'NA',
                 screen_name: 'Store',
                 section_name: 'Article Section' ,
          });
              } else {
               
              }
            });
          };
  
          const observer = new IntersectionObserver(handleIntersection, options);
          observer.observe(video);
        }
      }
    }, [data.items]);

  return (
    <ArticleContainer>
      <p className="head">
        Stay Informed <span className="subHead"> and Inspired</span>
      </p>
      <div className="container" ref={scrollRef}>
        {data?.items?.map((ele, index) => {
          return (
            <div id={`${sectionId}-${index}`}key={'art' + index} className="innerContainer"
            ref={(el) => {
              if (el) {
                itemRefs.current[index] = el;
              } else {
                itemRefs.current[index] = null;
              }
            }}
            data-index={index}
            >
              <AnchorCoverTag
                url={ele?.webUrl}
                cardEffect={cardEffect?.index === index ? 'lowOpacity' : ''}
                callbackFunction={() => callbackFunction(index, ele)}
                index={index}
              >
                <div className="imageSection">
                  <img src={ele?.image} alt="" />
                </div>

                <div className="textSection">
                  <p className="title">{ele?.title}</p>
                  <div
                    className="description"
                    dangerouslySetInnerHTML={{
                      __html: ele?.body,
                    }}
                  />
                </div>
              </AnchorCoverTag>
            </div>
          );
        })}
      </div>

      <div className="viewAllButton">
        <AnchorCoverTag
          url={`/parenting`}
          cardEffect={cardEffect?.index === -1 ? 'lowOpacity' : ''}
          callbackFunction={() =>
            callbackFunction(-1, { webUrl: `/parenting` })
          }
        >
          <p>View All</p>
        </AnchorCoverTag>
      </div>
    </ArticleContainer>
  );
}

export default ArticleCardsHome;
